<template>
  <a-row :gutter="24">
    <a-col :md="24">
      <a-card :style="cardStyle" :bordered="false">
        <template v-if="!printMode">
          <div class="table-page-search-wrapper">
            <a-form layout="inline" @keyup.enter.native="searchQuery">
              <a-row :gutter="24">
                <a-col :md="6" :sm="24">
                  <a-form-item label="门店" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <store-tenant-select domain="capital" @change="handleStoreTenantChange"></store-tenant-select>
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24">
                  <a-form-item label="单据编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input placeholder="请输入单据编号" v-model="queryParam.billNo"></a-input>
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24">
                  <a-form-item label="往来单位" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select placeholder="请选择往来单位" v-model="queryParam.organId"
                              :dropdownMatchSelectWidth="false" showSearch allow-clear
                              optionFilterProp="children" @search="handleSearchOrgan">
                      <a-select-option v-for="(item,index) in organList" :key="index" :value="item.id">
                        {{ item.supplier }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24">
                  <a-form-item label="单据日期" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-range-picker
                      style="width: 100%"
                      v-model="queryParam.dateRange"
                      format="YYYY-MM-DD"
                      :placeholder="['开始日期', '结束日期']"
                      @change="onDateChange"
                    />
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24">
                  <span class="table-page-search-submitButtons">
                    <a-button type="primary" @click="searchQuery">查询</a-button>
                    <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>
                    <a-button style="margin-left: 8px" icon="printer" v-if="btnEnableList.indexOf('5')>-1" @click="handlePrint">打印</a-button>
                    <a-button style="margin-left: 8px" @click="exportExcel" icon="download" v-if="btnEnableList.indexOf('3')>-1">导出</a-button>
                    <a @click="toggleSearchStatus = !toggleSearchStatus" style="margin-left: 8px">
                      {{ toggleSearchStatus ? '收起' : '展开' }}
                      <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
                    </a>
                  </span>
                </a-col>
              </a-row>
              <template v-if="toggleSearchStatus">
                <a-row :gutter="24">
                  <a-col :md="6" :sm="24">
                    <a-form-item label="财务人员" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-select placeholder="请选择财务人员" showSearch allow-clear
                                optionFilterProp="children" v-model="queryParam.handsPersonId">
                        <a-select-option v-for="(item,index) in personList" :key="index" :value="item.id">
                          {{ item.name }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24">
                    <a-form-item label="操作员" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-select placeholder="请选择操作人员" showSearch allow-clear
                                optionFilterProp="children" v-model="queryParam.creator">
                        <a-select-option v-for="(item,index) in userList" :key="index" :value="item.id">
                          {{ item.userName }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24">
                    <a-form-item label="账户信息" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-select placeholder="请选择帐户信息" showSearch allow-clear
                                optionFilterProp="children" v-model="queryParam.accountId">
                        <a-select-option v-for="(item,index) in accountList" :key="index" :value="item.id">
                          {{ item.name }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24">
                    <a-form-item label="单据类别" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-select placeholder="请选择单据类别" allow-clear
                                v-model="queryParam.type" @change="onTypeChange">
                        <a-select-option value="收款">收款</a-select-option>
                        <a-select-option value="付款">付款</a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24">
                    <a-form-item label="明细单号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-input placeholder="请输入采购或销售单号" v-model="queryParam.billNumber"></a-input>
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24">
                    <a-form-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-input placeholder="请输入备注" v-model="queryParam.remark"></a-input>
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24" v-if="orgaTree.length">
                    <a-form-item label="机构" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-tree-select style="width:100%" allow-clear :treeData="orgaTree"
                                     v-model="queryParam.organizationId" placeholder="请选择机构">
                      </a-tree-select>
                    </a-form-item>
                  </a-col>
                </a-row>
              </template>
            </a-form>
          </div>
          <section ref="print" id="reportPrint">
            <a-table
              bordered
              ref="table"
              size="middle"
              rowKey="rowIndex"
              :columns="columns"
              :dataSource="dataSource"
              :pagination="false"
              :scroll="scroll"
              :loading="loading"
              @change="handleTableChange">
              <span slot="billNoCustomRender" slot-scope="text, record">
                <a @click="handleBillNoClick(record)">{{ record.billNo }}</a>
              </span>
              <span slot="billNumberCustomRender" slot-scope="text, record">
                <a @click="handleBillNumberClick(record)">{{ record.billNumber }}</a>
              </span>
            </a-table>
            <a-row :gutter="24" style="margin-top: 8px; text-align: right">
              <a-col :md="24" :sm="24">
                <a-pagination
                  @change="paginationChange"
                  @showSizeChange="paginationShowSizeChange"
                  size="small"
                  show-size-changer
                  show-quick-jumper
                  :current="ipagination.current"
                  :page-size="ipagination.pageSize"
                  :page-size-options="ipagination.pageSizeOptions"
                  :total="ipagination.total"
                  :show-total="(total) => `共 ${total} 条`">
                  <template slot="buildOptionText" slot-scope="props">
                    <span>{{ props.value }}条/页</span>
                  </template>
                </a-pagination>
              </a-col>
            </a-row>
          </section>
        </template>
        <!-- 打印模式（内嵌） -->
        <template v-if="printMode">
          <div class="print-header" style="display:flex; justify-content:space-between; align-items:center; padding:8px 16px; background:#fff; border-bottom:1px solid #e8e8e8; margin-bottom:12px;">
            <span style="font-size:16px; font-weight:500;">{{ printTitle }}</span>
            <a-button icon="close" @click="printMode = false">关闭</a-button>
          </div>
          <ReportPrint
            :visible="true"
            :tableData="dataSource"
            :queryParam="queryParam"
            billType="MONEY_DETAIL"
            billTypeName="收付款明细"
            :buildData="buildPrintData"
            :embedded="true"
            @designer-change="onDesignerChange"
          />
        </template>
      </a-card>
    </a-col>
    <financial-detail ref="financialDetail"></financial-detail>
    <bill-detail ref="billDetail"></bill-detail>
  </a-row>
</template>
<script>
import { getList } from '@/api/plugin/moneyDetail'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { getAction, postAction } from '@/api/manage'
import ReportPrint from '@/views/plugin/print-template/ReportPrint.vue'
import StoreTenantSelect from '@/components/StoreTenantSelect'
import FinancialDetail from '@/views/financial/dialog/FinancialDetail'
import BillDetail from '@/views/bill/dialog/BillDetail'
import { findFinancialDetailByNumber, findBillDetailByNumber, getAllOrganizationTreeByUser } from '@/api/api'
import { buildPrintData, defColumns } from './moneyDetailConfig'
import moment from 'moment'

export default {
  name: "MoneyDetailList",
  mixins: [JeecgListMixin],
  components: {
    ReportPrint,
    StoreTenantSelect,
    FinancialDetail,
    BillDetail
  },
  data() {
    return {
      urlPath: '/plugin/moneyDetail',
      labelCol: { span: 6 },
      wrapperCol: { span: 17, offset: 1 },
      toggleSearchStatus: false,
      queryParam: {
        billNo: '',
        organId: undefined,
        dateRange: [moment().subtract(3, 'months'), moment()],
        beginTime: moment().subtract(3, 'months').format('YYYY-MM-DD'),
        endTime: moment().format('YYYY-MM-DD'),
        handsPersonId: undefined,
        creator: undefined,
        accountId: undefined,
        type: undefined,
        billNumber: '',
        remark: '',
        organizationId: undefined
      },
      ipagination: {
        current: 1,
        pageSize: 11,
        pageSizeOptions: ['10', '20', '30', '50', '100'],
        total: 0
      },
      organList: [],
      personList: [],
      userList: [],
      accountList: [],
      orgaTree: [],
      defColumns: defColumns,
      url: {
        list: '/api/plugin/money-detail/moneyDetail/getList'
      },
      printMode: false,
      printTitle: '收付款明细-打印预览'
    }
  },
  created() {
    this.columns = this.defColumns
    this.initOrgan()
    this.initPerson()
    this.initUser()
    this.initAccount()
    this.initOrga()
  },
  methods: {
    buildPrintData,
    moment,
    handleStoreTenantChange() {
      this.searchQuery()
    },
    onDateChange(dates, dateStrings) {
      this.queryParam.beginTime = dateStrings[0]
      this.queryParam.endTime = dateStrings[1]
    },
    onTypeChange(value) {
      // 单据类别联动收支项目（预留）
    },
    initOrgan() {
      postAction('/supplier/findBySelect_organ', { limit: 1 }).then((res) => {
        if (res) {
          this.organList = res
        }
      })
    },
    handleSearchOrgan(value) {
      postAction('/supplier/findBySelect_organ', { key: value, limit: 1 }).then((res) => {
        if (res) {
          this.organList = res
        }
      })
    },
    initPerson() {
      getAction('/person/getPersonByType', { type: '财务员' }).then((res) => {
        if (res && res.code === 200 && res.data) {
          this.personList = res.data.personList || []
        }
      })
    },
    initUser() {
      getAction('/user/getUserList').then((res) => {
        if (res) {
          this.userList = res
        }
      })
    },
    initAccount() {
      getAction('/account/getAccount').then((res) => {
        if (res && res.code === 200 && res.data) {
          this.accountList = res.data.accountList || []
        }
      })
    },
    initOrga() {
      getAllOrganizationTreeByUser({}).then((res) => {
        this.orgaTree = res || []
      })
    },
    searchQuery() {
      this.ipagination.current = 1
      this.loadData()
    },
    searchReset() {
      this.queryParam = {
        billNo: '',
        organId: undefined,
        dateRange: [moment().subtract(3, 'months'), moment()],
        beginTime: moment().subtract(3, 'months').format('YYYY-MM-DD'),
        endTime: moment().format('YYYY-MM-DD'),
        handsPersonId: undefined,
        creator: undefined,
        accountId: undefined,
        type: undefined,
        billNumber: '',
        remark: '',
        organizationId: undefined
      }
      this.ipagination.current = 1
      this.loadData()
    },
    loadData() {
      const params = {
        billNo: this.queryParam.billNo || undefined,
        organId: this.queryParam.organId || undefined,
        beginTime: this.queryParam.beginTime || undefined,
        endTime: this.queryParam.endTime || undefined,
        handsPersonId: this.queryParam.handsPersonId || undefined,
        creator: this.queryParam.creator || undefined,
        accountId: this.queryParam.accountId || undefined,
        type: this.queryParam.type || undefined,
        billNumber: this.queryParam.billNumber || undefined,
        remark: this.queryParam.remark || undefined,
        organizationId: this.queryParam.organizationId || undefined,
        currentPage: this.ipagination.current,
        pageSize: this.ipagination.pageSize - 1
      }
      this.loading = true
      getList(params).then(res => {
        this.loading = false
        if (res && res.code === 200 && res.data) {
          const rows = res.data.rows || []
          rows.forEach((row, i) => {
            row.rowIndex = (this.ipagination.current - 1) * (this.ipagination.pageSize - 1) + i + 1
          })
          this.dataSource = rows
          this.ipagination.total = res.data.total || 0
          this.tableAddTotalRow(this.columns, this.dataSource)
        } else {
          this.dataSource = []
          this.ipagination.total = 0
        }
      }).catch(err => {
        this.loading = false
        this.$message.error('查询失败: ' + (err.message || '未知错误'))
        console.error(err)
      })
    },
    tableAddTotalRow(columns, dataSource) {
      if (dataSource.length > 0) {
        let numKey = 'rowIndex'
        let totalRow = { [numKey]: '合计' }
        let parseCols = 'needDebt,moneyInAmount,moneyOutAmount,'
        columns.forEach(column => {
          let { key, dataIndex } = column
          if (![key, dataIndex].includes(numKey)) {
            let total = 0
            let hasSum = false
            dataSource.forEach(data => {
              if (parseCols.indexOf(dataIndex + ',') > -1) {
                hasSum = true
                if (data[dataIndex]) {
                  total += Number.parseFloat(data[dataIndex])
                }
              }
            })
            if (hasSum) {
              totalRow[dataIndex] = total.toFixed(2)
            } else {
              totalRow[dataIndex] = ''
            }
          }
        })
        dataSource.push(totalRow)
        let size = Math.ceil(this.ipagination.total / (this.ipagination.pageSize - 1))
        this.ipagination.total = this.ipagination.total + size
      }
    },
    handlePrint() {
      if (!this.dataSource || this.dataSource.length === 0) {
        this.$message.warning('暂无数据可打印')
        return
      }
      this.printTitle = '收付款明细-打印预览'
      this.printMode = true
    },
    onDesignerChange(visible) {
      this.printTitle = visible ? '收付款明细-报表设计' : '收付款明细-打印预览'
    },
    paginationChange(page, pageSize) {
      this.ipagination.current = page
      this.ipagination.pageSize = pageSize
      this.loadData()
    },
    paginationShowSizeChange(current, size) {
      this.ipagination.current = 1
      this.ipagination.pageSize = size
      this.loadData()
    },
    handleTableChange(pagination, filters, sorter) {
      // 表格变化处理
    },
    handleBillNoClick(record) {
      const prefixNo = record.type === '收款' ? 'SK' : 'FK'
      this.$refs.financialDetail.show({ billNo: record.billNo }, record.type, prefixNo)
    },
    handleBillNumberClick(record) {
      if (!record.billNumber) return
      findBillDetailByNumber({ number: record.billNumber }).then((res) => {
        if (res && res.code === 200) {
          this.$refs.billDetail.isCanBackCheck = false
          const depotHeadType = res.data.depotHeadType || res.data.type
          this.$refs.billDetail.show(res.data, depotHeadType)
          this.$refs.billDetail.title = depotHeadType + '-详情'
        }
      })
    },
    exportExcel() {
      const list = []
      const head = '单据编号,往来单位,财务人员,操作员,账户信息,单据类别,采购或销售单号,原欠款,收款,付款,单据日期,备注'
      const exportData = this.dataSource.filter(item => item.rowIndex !== '合计')
      for (let i = 0; i < exportData.length; i++) {
        const ds = exportData[i]
        list.push([
          ds.billNo || '',
          ds.organName || '',
          ds.handsPersonName || '',
          ds.userName || '',
          ds.accountName || '',
          ds.type || '',
          ds.billNumber || '',
          ds.needDebt || 0,
          ds.moneyInAmount || 0,
          ds.moneyOutAmount || 0,
          ds.billTimeStr || '',
          ds.remark || ''
        ])
      }
      let tip = '查询条件'
      if (this.queryParam.beginTime && this.queryParam.endTime) {
        tip += ', 日期=' + this.queryParam.beginTime + '~' + this.queryParam.endTime
      }
      if (this.queryParam.type) {
        tip += ', 类别=' + this.queryParam.type
      }
      // 添加合计行
      let totalItem = ['-', '-', '-', '-', '-', '-', '-', 0, 0, 0, '-', '-']
      for (let i = 0; i < exportData.length; i++) {
        const ds = exportData[i]
        totalItem[7] += Number.parseFloat(ds.needDebt || 0)
        totalItem[8] += Number.parseFloat(ds.moneyInAmount || 0)
        totalItem[9] += Number.parseFloat(ds.moneyOutAmount || 0)
      }
      totalItem[7] = totalItem[7].toFixed(2)
      totalItem[8] = totalItem[8].toFixed(2)
      totalItem[9] = totalItem[9].toFixed(2)
      list.push(totalItem)
      this.handleExportXlsPost('收付款明细', '收付款明细', head, tip, list)
    }
  }
}
</script>
<style scoped>
</style>